<template>
  <div>
    <div class="order-check-box">
      <div class="total-order">
        <div>
          合计<span v-if="showOrderNum">{{ payData.totalOrderCount }}笔运单</span>
        </div>
        <div>
          <span class="mr-15">装货{{ payData.originalUnit }}吨</span>
          <span>卸货{{ payData.actualUnit }}吨</span>
        </div>
      </div>
      <div class="detail-content">
        <div class="order-pay-content">
          <div class="order-pay">
            <img src="../../../assets/img/total-pay.png" width="88px" height="100%" />
            <div class="pay-detail">
              <div class="detail-top">
                <span class="total">¥{{ payData.totalNeedPay | thousands(2) }}</span>
                <span class="dec font-red" v-if="payData.totalAddMoney > 0"
                  >含追加¥{{ payData.totalAddMoney | thousands(2) }}</span
                >
              </div>
              <div class="detail-bottom" v-if="!(payData.cashNeedPay > 0 && payData.accountNeedPay > 0)">
                <img
                  v-if="payData.cashNeedPay > 0"
                  width=" 56px"
                  height="18px"
                  src="../../../assets/img/tag_yezf.png"
                  alt=""
                />
                <img
                  v-if="payData.accountNeedPay > 0"
                  width=" 56px"
                  height="18px"
                  src="../../../assets/img/tag_zqzf.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="pay-yue-zz" v-if="payData.cashNeedPay > 0 && payData.accountNeedPay > 0">
            <div class="order-pay-item">
              <img src="../../../assets/img/tag_yezf.png" alt="" />
              <div class="mt-5">
                <span class="dec">￥{{ payData.cashNeedPay | thousands(2) }}</span>
                <span class="dec add" v-if="payData.cashAddMoney > 0"
                  >（含追加￥{{ payData.cashAddMoney | thousands(2) }}）</span
                >
              </div>
            </div>
            <div class="line"></div>
            <div class="order-pay-item">
              <img src="../../../assets/img/tag_zqzf.png" alt="" />
              <div class="mt-5">
                <span class="dec">￥{{ payData.accountNeedPay | thousands(2) }}</span>
                <span class="dec add" v-if="payData.accountAddMoney > 0"
                  >（含追加￥{{ payData.accountAddMoney | thousands(2) }}）</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="fee-detail">
          <div class="fee-detail-item">
            <span class="name">司机运费：</span>
            <span class="fee">¥{{ payData.totalActualPay || 0 | thousands(2) }}</span>
          </div>
          <div class="fee-detail-item">
            <span class="name">调度费：</span>
            <span class="fee">¥{{ payData.totalScheduleFee || 0 | thousands(2) }}</span>
          </div>
          <div class="fee-detail-item" v-if="payData.totalCargoGuaranteePrice > 0">
            <span class="name">货保费：</span>
            <span class="fee">¥{{ payData.totalCargoGuaranteePrice | thousands(2) }}</span>
          </div>
          <div class="fee-detail-item" v-if="payData.totalServerMoney > 0">
            <span class="name">服务费：</span>
            <span class="fee">¥{{ payData.totalServerMoney | thousands(2) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    payData: {
      type: Object,
      default: () => {}
    },
    showOrderNum: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="postcss">
.pay-check-dialog {
  width: 650px;
  .el-input__inner {
    height: 44px;
  }
  .pay-text {
    margin-top: 40px;
    margin-bottom: 10px;
    color: #333;
  }
}
.order-check-box {
  padding-bottom: 14px;
  color: #333;
  .total-order {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
  }
  .detail-content {
    padding: 24px 20px;
    background: linear-gradient(360deg, #ffffff 0%, #f7fffd 100%);
    box-shadow: 0px 2px 5px 0px rgba(232, 237, 236, 0.3);
    border-radius: 8px;
    border: 1px solid #f7faf9;
    .order-pay-content {
      border-bottom: 1px dashed #e9e9e9;
      padding-bottom: 16px;
      .order-pay {
        display: flex;
        align-items: center;
        height: 88px;
        .pay-detail {
          margin-left: 10px;
          .detail-top {
            height: 33px;
            display: flex;
            align-items: center;
            .total {
              font-size: 24px;
              font-weight: bold;
              color: #333333;
            }
            .dec {
              line-height: 22px;
              padding: 0 6px;
              margin-left: 8px;
              background: #fff7f7;
              border-radius: 2px;
            }
          }
        }
      }
      .pay-yue-zz {
        display: flex;
        align-items: center;
        padding-left: 98px;
        margin-top: -15px;
        img {
          width: 56px;
          height: 18px;
        }
        .line {
          width: 1px;
          height: 38px;
          margin: 0 16px;
          background: #e9e9e9;
        }
        .order-pay-item {
          width: 49%;
          img {
            width: 56px;
            height: 18px;
          }
          .dec {
            line-height: 20px;
            color: #333;
            &.add {
              color: #aaa;
            }
          }
        }
      }
    }
    .fee-detail {
      .fee-detail-item {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        .name {
          color: #aaa;
        }
      }
    }
  }
  .order-check {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    .order-check-result {
      height: 36px;
      align-items: center;
      margin-bottom: 0;
      .name {
        width: 75px;
        color: #58626b;
      }
      .desc {
        flex: 1;
      }
    }
  }
}
</style>
